import React, { Component } from 'react';
import Service from '../service/Service';
const service = new Service();
import * as actions from './actions';
import Cookies from "js-cookie";
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import './Babynames.css';
import { fetchInitialData } from "../fetchData";
import { Bling as GPT } from "react-gpt";

var items = [];
var recordID = "";
var babynametoadd = "";
class BabynameDetail extends Component {
    constructor(props) {
        super(props)
        let initialData = {};
        let details = [];
        let window_width = '';
        let collectionListData = [];
        this.alphabetsAry = [];
        var metaTitle = '';
        var metoDescription = [];
        var babyName = '';
        for (let i = 0; i < 26; i++) {
            this.alphabetsAry.push((i + 10).toString(36));
        }
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            if(window.__initialData__['initialData']['SearchData'] !== "Records Not Found") {
                var bname = window.location.pathname.split("/")[2].split("-")[2].charAt(0).toUpperCase() + window.location.pathname.split("/")[2].split("-")[2].slice(1);
            
                metaTitle = bname + ": Meaning of " + bname + " | FirstCry Baby Names Finder";
            
                details = window.__initialData__['initialData']['SearchData'];
            
                if(details && details[0] && details[0].indexFlag == 1){
                    metoDescription =  [
                        { "name": "description", "content": "Find meaning of name " + bname +", its synonyms, religion, numerology, similar names and other details with FirstCry baby name finder." },
                        { "name": "keywords", "content": "" + bname +" meaning, " + bname + " baby name meaning, meaning of " + bname + "" },
                        // { "name" : "robots", "content" : "noindex"}
                    ]
                } else {
                    metoDescription =  [
                        { "name": "description", "content": "Find meaning of name " + bname +", its synonyms, religion, numerology, similar names and other details with FirstCry baby name finder." },
                        { "name": "keywords", "content": "" + bname +" meaning, " + bname + " baby name meaning, meaning of " + bname + "" },
                        // { "name": "ROBOTS", "content": "all" }
                    ]
                }
            } else {
                details = ["Records Not Found"]
            }
            
            delete window.__initialData__;
        } else {
            // console.log(props.staticContext.initialData['initialData'])
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
               if(props.staticContext.initialData['initialData']['SearchData'] !== "Records Not Found") {
                    details = props.staticContext.initialData['initialData']['SearchData'];

                    var bname = props.match.url.split("/")[2].split("-")[2].charAt(0).toUpperCase() + props.match.url.split("/")[2].split("-")[2].slice(1);
                
                    metaTitle = bname + ": Meaning of " + bname + " | FirstCry Baby Names Finder";
                    
                    if(details && details[0] && details[0].indexFlag == 1){
                        metoDescription =  [
                            { "name": "description", "content": "Find meaning of name " + bname +", its synonyms, religion, numerology, similar names and other details with FirstCry baby name finder." },
                            { "name": "keywords", "content": "" + bname +" meaning, " + bname + " baby name meaning, meaning of " + bname + "" },
                            { "name" : "robots", "content" : "noindex"}
                        ]
                    }  else {
                        metoDescription =  [
                            { "name": "description", "content": "Find meaning of name " + bname +", its synonyms, religion, numerology, similar names and other details with FirstCry baby name finder." },
                            { "name": "keywords", "content": "" + bname +" meaning, " + bname + " baby name meaning, meaning of " + bname + "" },
                            { "name": "ROBOTS", "content": "all" }
                        ]
                    }
               } else {
                details = ["Records Not Found"]
               }
            }
        }
        this.state = {
            initialData: initialData,
            details : details,
            window_width : window_width,
            collectionListData: collectionListData,
            babyName : babyName,
            metaTitle: metaTitle,
            metaDescription: metoDescription
        };
    }
    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {
       
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl && reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        var recordid_arr = [];
        if(cookieData && cookieData.includes("babynamemeaning")){
            var cookieAry = cookieData.split(';');
            
            for (var i = 0; i < cookieAry.length; i++) {
                if (cookieAry[i] && cookieAry[i].includes("babynamemeaning")) {

                    var new_arr = cookieAry[i].split('babynamemeaning=')[1].replace(/%2C/g, ",").replace(/"/g, '').slice(1,-1).split(",");
                   
                    for(var j = 0; j < new_arr.length ; j++){
                        var _name = reqUrl.split("meaning-of-")[1].split("?")[0];

                        if(_name && _name.includes("-")){

                            if((_name.split("-")[0] + " " + _name.split("-")[1]).toLowerCase() == decodeURI(new_arr[j]).slice(1,-1).split("-")[0].toLowerCase()+"/"){
                          
                                var babynameId = decodeURI(new_arr[j]).slice(1,-1).split("-")[1];
                                
                                var bbname = decodeURI(new_arr[j]).slice(1,-1).split("-")[0];
                            }
                        } else {
                            if(_name.toLowerCase() == decodeURI(new_arr[j]).slice(1,-1).split("-")[0].toLowerCase()+"/"){
                                var babynameId = decodeURI(new_arr[j]).slice(1,-1).split("-")[1];
                                
                                var bbname = decodeURI(new_arr[j]).slice(1,-1).split("-")[0];
                            }
                        }
                    }
                }
            }
        }

        var babynameRecordID = babynameId;
        var babyname = bbname;

        if(reqUrl.split("meaning-of-")[1].split("?")[0].includes("/")){
            var nameFromurl = reqUrl.split("meaning-of-")[1].split("?")[0].split("/")[0]
        } else {
            var nameFromurl = reqUrl.split("meaning-of-")[1].split("?")[0];
        }
        var url = global.api_url + "getbabydetails";
        var body = JSON.stringify({
            "recordId": babynameRecordID,
            "babyName": nameFromurl
        });
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        document.addEventListener("click", actions.domClick);
        var urlpath = window.location.href;
         
        var discussion_page = window.location.pathname.split('meaning-of-')[1].split("?")[0];

        var babyname = discussion_page.split("/")[0].replace("-", " ");
        if(babyname && babyname.includes("/")){
            var _namefromurl = babyname.split("/")[0];
        } else {
            var _namefromurl = babyname;
        }
        if (navigator.onLine) {
            if(this.state.details.length == 0 ){
                this.babynameDetail(_namefromurl);
            }
        } else {
            if(localStorage.getItem('babynamedetails')){
                this.setState({ details: JSON.parse(localStorage.getItem('babynamedetails')) });
            }
            service.showLoader();
            setTimeout(function(){
                service.hideLoader();
            }, 500)
        }
        window.scrollTo(0,0);
        this.setState({window_width : window.innerWidth});
        this.setState({babyName : _namefromurl})

        if(urlpath.includes("?shortlist=1")){
            document.querySelector(".detailname_hearticon").click();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
    }

    babynameDetail(babyname){
        if(Cookies.get("babynamemeaning")){
            var new_arr = (Cookies.get("babynamemeaning")).replace(/%2C/g, ",").replace(/"/g, '').slice(1,-1).split(",");
            
            for(var j = 0; j < new_arr.length ; j++){
                
                if(babyname.toLowerCase() == (new_arr[j]).split("-")[0].toLowerCase()){
                    var babynameId = (new_arr[j]).split("-")[1];
                }
            }
        } else {
            var babynameId =  '';
        }
        var postData = {
            "recordId" : babynameId,
            "babyName" : babyname,
        }
        var url = global.api_ci_url + "Babynames/getbabydetails";
        service.postServiceCall(url, postData).then((json) => {
            if(json['msg'] == 1){
                if(this.state.details && this.state.details.length > 0){
                this.setState({ details : json['SearchData']});
                } else {
                    localStorage.setItem('babynamedetails', JSON.stringify(json['SearchData']));                   
                    this.setState({ details: json['SearchData'] }, () => {service.loadImages(); actions.loadSliders();});

                    this.setState({metaTitle:  babyname + ": Meaning of " + babyname + " | FirstCry Baby Names Finder"});
                }
            } else {
                this.setState({ details : ["Records Not Found"]});
            }
        }).catch((error) => {
            console.error(error);
        });
    }
    heartclick(event, recordId, nametoAdd) {
        if (global.ftk === '') {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        } else {
            if(event.target.classList.contains('heartselected')){
               event.target.setAttribute("data-icon-font", "+")
               event.target.className = event.target.className.replace(/\heartselected\b/, "");
            } else {
                document.querySelector('.collection-part1').style.display = "block";
                document.querySelector('.new-collection').style.display = "none";
                document.querySelector('.collection-list-popup').style.display = "block";
                document.querySelector("body").style.overflow = "hidden";
                event.target.className += " openpopup";
                
                var favouriteId = "";
                recordID = recordId;
                babynametoadd = nametoAdd;
            }
            var postData = {
                "pageSize": "10",
                "pageNo": 1
            }
            var url =  global.api_ci_url + "Babynames/getmyfavouritelist";
   
            service.postServiceCall(url, postData).then((json) => {
                if(json['FinalResponse'] !== 'Records Not Found'){
                   this.setState({collectionListData : json['FinalResponse']});
                } else {
                   document.querySelector(".norecord-overlay").style.display = "block";
                //    document.querySelector(".collection-part1").querySelector(".list").style.display = "none";
                }
                service.loadImages();
                actions.loadSliders();
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            
        }
    }
    CollectionListPopup(eleRef, eleRecord, eleName, elem) {
        var items = [];
        [].forEach.call(eleRef, function (value, key) {
            items.push(<li key={key} className="dev_selcoll" onClick={(e) => elem.selectlist(`${eleRecord}`, `${value.coll_id}`, `${eleName}`)}>
                <div className="baby_img">
                    <img src="http://cdn.fcglcdn.com/brainbees/apps/image/baby_name_icon.png" className="dev_selcollimg" />
                </div>
                <div className="M14_42">
                    <span className="coll_title"> {value.coll_name} </span>
                </div>
                <div className="M14_pink">
                    <span className="dev_selcoll"> {value.count} </span>
                    <span className="dev_selcolltxt"> Name(s) </span>
                </div>
            </li>
            )
        });
         
        return (
            
                <div className="collection-list-popup">
                    <div className="collection" onClick={(e) => this.collection_click()}>
                        <div className="collection-part1">
                            <span className="selct-title M18_42"> Select the collection list </span>
                            <span className="create-ic right" onClick={() => actions.createlist()} >
                                Create + 
                            </span>
                            <div className="list" id="list">
                                <ul className="collection-list" data-count={eleRef.length}>{items}</ul>
                            </div>
                            <span className="next" onClick={() => service.slideSlider('list', 300, 1000)}>
                                <span data-icon-font="h" className="icon"></span>
                            </span>
                            <span className="prev" onClick={() => service.slideSlider('list', -300, 1000)}>
                                <span data-icon-font="g" className="icon"></span>
                            </span>
                        </div>
                        { /*<!--norecord starts--> */}
                        <div className="norecord-overlay left">
                            <div className="norecord_alert">
                                <div className="M16_42">  No collection list created yet. </div>
                                <div className="R14_9e"> Please create the one to shortlist the cute baby names.
                                </div>
                            </div>
                        </div>
                        { /*<!--norecord ends--> */}
                        <div className="new-collection">
                            <div className="selct-title  M18_42"> Create New Collection </div>
                            <span className="M14_42"> Collection Name </span>
                            <input type="text"
                                placeholder="Family's, Father, Mother"
                                className="input-name"/>
                            <span className="error_msg R11_red"> </span>
                            <div className="popup-btns right">
                                <span className="cancel-popup M14_9e" onClick={(e) => actions.cancelCreate_popup(e)}> CANCEL </span>
                                <span className="M14_pink dev_create_addfavname" onClick={(e) => this.createNewCollection(e, this)}>
                                    CREATE 
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
        )
    }
    createNewCollection(event, elem) {
        var collectionName = event.target.parentElement.parentElement.querySelector(".input-name").value;
        if(/<(.|\n)*?>/g.test(collectionName)){
            event.target.parentElement.previousSibling.innerHTML = 'Script tags not allowed';
            event.target.parentElement.previousSibling.style.display = "block";
            event.target.parentElement.parentElement.querySelector(".input-name").value = '';
        }else{
            if (collectionName.trim() != "" & collectionName.length <= 100) {
                var postData = 
                {
                    "collection" : collectionName,
                    "pageNo" : 1,
                    "pageSize" : 10
                };
                var url = global.api_ci_url + "Babynames/postcollection";

                service.postServiceCall(url, postData).then((json) => {
                    document.querySelector('.collection-list-popup').style.display = "none";
                    document.getElementsByTagName('body')[0].style.overflow = "auto";

                    if (json['msg'] == "1") {
                        
                        elem.selectlist(recordID, json['result'], collectionName);
                    } else {
                      
                        document.querySelector(".nm-add span").innerHTML = collectionName + " already exists";
                        // document.querySelector('.name-added').stop().fadeIn(400).delay(1000).fadeOut(400);
                        document.querySelector(".name-added").classList += " add_show";
                  
                        setTimeout(() => {
                            if(document.getElementsByClassName('name-added')) {
                                document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
                            }
                        }, 1000);

                    }
                   document.querySelector(".input-name").value = '';
    
                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
            } else {
                event.target.parentElement.previousSibling.innerHTML = "Max 100 characters are allowed";
                event.target.parentElement.previousSibling.style.display = "block";
                document.querySelector(".input-name").value = '';
            }
        }

        [].forEach.call(document.querySelectorAll(".openpopup"), function(elem){
            elem.className = elem.className.replace(/\openpopup\b/, "");
        })
    }
    
    collection_click() {
        document.querySelector('.collection-list-popup').style.display = "block";
        document.querySelector("body").style.overflow = "hidden";
    }
    selectlist(recordId, collectionId, babyname) {
        var postData = {
            "recordId" : recordId,
            "collectionId" : collectionId,
            "favouriteId" : "",
            "action_status" : "1",
        }
        var url = global.api_ci_url + "Babynames/savefavouritename";
        service.postServiceCall(url, postData).then((json) => {
            service.hideLoader();
            if(json['msg'] == "1"){
                document.querySelector('.collection-list-popup').style.display = "none";
              
                setTimeout(() => {
                    var tempArray = this.state.details;

                   for(var i = 0; i < tempArray.length; i++){
                       if(tempArray[i].similarnames.length > 0){
                        [].forEach.call(tempArray[i].similarnames , function(ele){
                            if(ele.recordid == recordId){
                                ele.isShortlist = true;
                                ele.favouriteid = json['result'];
                            } else {
                                if(tempArray[i].recordid == recordId){
                                    tempArray[i].isShortlist = true;
                                    tempArray[i].favouriteid = json['result'];
                                }
                            }
                        })
                       } else {
                            if(tempArray[i].recordid == recordId){ 
                                tempArray[i].isShortlist = true;
                                tempArray[i].favouriteid = json['result'];
                            }
                       }
                       
                    }
                    this.setState({ details: tempArray});
                
                }, 500);
                
                document.querySelector(".nm-add span").innerHTML = babyname + " has been added to list";
    
                document.querySelector(".name-added").classList += " add_show";
                setTimeout(() => {
                    if(document.getElementsByClassName('name-added')) {
                        document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
                    }
                }, 1000);

            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    removeFromColl(recordId, favId, babyname, event){
        if (favId == "0") {
            var favouriteId = event.target.getAttribute("data-favId");
        } else {
            var favouriteId = favId;
        }
        var postData = {   
            "favouriteId" : favouriteId,
            "recordId": recordId,
            "collectionId": "",
            "action_status": "0"
        };
    
        var currentEle = event.target;
        var url = global.api_ci_url + "Babynames/savefavouritename";
        service.postServiceCall(url, postData).then((json) => {
            service.hideLoader();
            if(json['msg'] == "1"){

                setTimeout(() => {
                    var tempArray = this.state.details;
                    
                    for(var i = 0; i < tempArray.length; i++){
                        if(tempArray[i].similarnames.length > 0){
                         [].forEach.call(tempArray[i].similarnames , function(ele){
                             if(ele.recordid == recordId){
                                 ele.isShortlist = false;
                                 ele.favouriteid = 0;
                             } else {
                                 if(tempArray[i].recordid == recordId){
                                     tempArray[i].isShortlist = false;
                                     tempArray[i].favouriteid = 0;
                                 }
                             }
                         })
                        } else {
                             if(tempArray[i].recordid == recordId){ 
                                 tempArray[i].isShortlist = false;
                                 tempArray[i].favouriteid = 0;
                             }
                        }
                        
                     }
                    this.setState({ details: tempArray});
                }, 500);

                document.querySelector(".nm-add span").innerHTML = babyname + ' has been removed from list';
                document.querySelector(".name-added").classList += " add_show";
                    
                setTimeout(() => {
                    if(document.getElementsByClassName('name-added')) {
                        document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
                    }
                }, 1000);

            } else {
                window.location.href = service.getRedirectUrl(currentURL);
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    render() {
        var _collectionListData = this.state.collectionListData;
        function checkGender(gender){
            if(gender == "Boy") {
                return (<span className="gender-icon boy-icon icon left boy_icon" data-icon-font="&#xe022;"></span>)
            } else if(gender == "Girl"){ 
                return (<span className="gender-icon girl-icon icon left girl_icon" data-icon-font="&#xe01f;"></span>)
            }else{
                return (<span className="gender-icon icon left unisex_icon" data-icon-font="&#xe029;"></span>)
            }
        }

       if(this.state.details && this.state.details.length != 0){
         var _details = this.state.details;
       }
       var _name = this.props.location.pathname.split("meaning-of-")[1].split("/")[0];
      
       if(_name && _name.includes("-")){
            var name_split = _name.split("-");
            var _name_ = name_split.join(" ");
       } else {
         var _name_ = _name;
       }

        return (
            <main className="baby-names-main main-container">
                
                <div className="data-container">
                    <Helmet
                        title={this.state.metaTitle}
                        meta={this.state.metaDescription}
                    />
                    <div className="title">
                        <div className="breadcrumb R11_9e">
                            <span><Link className="R11_9e" to={service.getRedirectUrl("/")}>Home</Link></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><Link className="R11_9e" to={service.getRedirectUrl("/baby-names/")}>Baby Names</Link></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            {this.state.babyName && this.state.babyName != '' &&
                                <span>{this.state.babyName.charAt(0).toUpperCase() + this.state.babyName.slice(1)}</span>
                            }
                        </div>
                    </div>

                    <div className="baby-names-head">
                        {(this.state.window_width > 767) ? (<h1 className="B24_00">{`Meaning of ${_name_ && _name_ != '' && (_name_.charAt(0).toUpperCase() + _name_.slice(1))}`}</h1>) : (
                        <div className="mobile_listing">
                            <Link to={service.getRedirectUrl(`/baby-names/`)} title=""><span className="icon" data-icon-font="s"></span></Link>

                            <h1 className="M16_white">{`Meaning of ${_name_ && _name_ != '' && (_name_.charAt(0).toUpperCase() + _name_.slice(1))}`}</h1>
                        </div>)}
                    </div>
                    <div className="sub-container">
                    {
                        (_details && _details[0] && _details[0] != "Records Not Found") ? (
                        <div className="name-details-main">
                            <div className="name-details-top">
                                <ul className="name-details" id="name-det">
                                    <li>
                                        <span className="det-catg left M14_42">
                                            Name <span className="right">:</span>
                                        </span>
                                        <span className="catg-info R14_42">
                                            {_details[0].babyname}
                                        </span>
                                    </li>
                                    {
                                        (_details[0].meaning) ?
                                        (
                                            <li>
                                                <span className="det-catg left M14_42">Meaning <span className="right">:</span></span>
                                                <span className="catg-info R14_42">{_details[0].meaning}</span>
                                            </li>
                                        ) :
                                        ''
                                    }
                                    {
                                        (_details[0].gender) ?
                                        (
                                            <li>
                                                <span className="det-catg left M14_42">Gender <span className="right">:</span></span>
                                                <span className="catg-info R14_42">{_details[0].gender}</span>
                                            </li>
                                        ) :
                                        ''
                                    }
                                    {
                                        (_details[0].numerology) ?
                                        (
                                            <li>
                                                <span className="det-catg left M14_42">Numerology <span className="right">:</span></span>
                                                <span className="catg-info R14_42">{_details[0].numerology}</span>
                                            </li>
                                        ) :
                                        ''
                                    }
                                    
                                    {
                                        (_details[0].syllables) ?
                                        (
                                            <li>
                                                <span className="det-catg left M14_42">Syllables <span className="right">:</span></span>
                                                <span className="catg-info R14_42">{_details[0].syllables}</span>
                                            </li>
                                        ) :
                                        ''
                                    }
                                    
                                    {
                                        (_details[0].religion) ?
                                        (
                                            <li>
                                                <span className="det-catg left M14_42">Religion <span className="right">:</span></span>
                                                <span className="catg-info R14_42">{_details[0].religion}</span>
                                            </li>
                                        ) :
                                        ''
                                    }
                                    
                                    {
                                        (_details[0].rashi) ?
                                        (
                                            <li>
                                                <span className="det-catg left M14_42">Rashi <span className="right">:</span></span>
                                                <span className="catg-info R14_42">{_details[0].rashi}</span>
                                            </li>
                                        ) :
                                        ''
                                    }
                                    
                                    {
                                        (_details[0].nakshatra) ?
                                        (<li>
                                            <span className="det-catg left M14_42">Nakshatra <span className="right">:</span></span>
                                            <span className="catg-info R14_42">{_details[0].nakshatra}</span>
                                        </li>) :
                                        ''
                                    }

                                    </ul>
                                    <div className="share-sel-ic" id={_details[0].recordid}>
                                        <div className="card-share left">
                                            <div onClick={(e) => actions.shareOn(e)} className="R14_9e left shareIcon">
                                                <div className="left R13_9e fbimg">
                                                    <img className="fbimg" src="//parenting.firstcry.com/personalized-feed/images/facebook-icon.png" alt="facebook" title="facebook" />
                                                </div>
                                                <div data-icon-font="" className="icon left whatsappIcon"></div>
                                                <div className="left M14_9e">Share</div>
                                            </div>
                                            
                                            <div className="sharing-options">
                                                <ul>
                                                    <li className="whatsapp-share left" onClick={(e) => actions.shareList(e, `whatsapp`)} data-name={_details[0].babyname}>
                                                        <span className="M16_61 social-share" id="whatsapp">
                                                            <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../assets/images/whatsapp.png')} className="loadingImg facebookimg" alt="" />
                                                        </span>
                                                    </li>

                                                    <li className="facebook-share left" onClick={(e) => actions.shareList(e, `facebook`)} data-name={_details[0].babyname}>
                                                        <span className="M16_61 social-share" id="facebook">
                                                            <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../assets/images/facebook.png')} className="loadingImg facebookimg" alt="" />
                                                        </span>
                                                    </li>
                                                    <li className="twitter-share left post_share tw_share" onClick={(e) => actions.shareList(e, `twitter`)} data-name={_details[0].babyname}>
                                                        <div className="M16_61 social-share post_share tw_share" id="twitter">
                                                            <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../assets/images/twitter.png')} className="loadingImg twitterimg" alt="" />
                                                        </div>
                                                    </li>
                                                    <li className="twitter-share left post_share pi_share" onClick={(e) => actions.shareList(e, `pintrest`)} style={{margin : '0 0 0 10px'}} data-name={_details[0].babyname}>
                                                        <div className="M16_61 social-share post_share pi_share" id="pintrest">
                                                            <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif"  data-src={require('../assets/images/pintrest.png')} className="loadingImg pintrestimg" alt="" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="share-overlay"></div>
                                        </div>
                                      
                                        {
                                            (_details[0].isShortlist) ? 
                                            (
                                                <div className="right">
                                                    <span className="heart-icon detailname_hearticon isChecked right" data-icon-font="}" onClick={(e) => this.removeFromColl(`${_details[0].recordid}`,`${_details[0].favouriteid}` , `${_details[0].babyname}`, e)} data-favId={_details[0].favouriteid}></span>
                                                </div>
                                            )
                                            :
                                            (
                                            <div className="right">
                                                <span className="heart-icon detailname_hearticon right" data-icon-font="+" onClick={(e) => this.heartclick(e, `${_details[0].recordid}`, `${_details[0].babyname}`)}></span>
                                            </div>
                                            )
                                        }
                                    </div>
                                </div>
                                {/* <div>
                                    <div className="desktop-ads-block">
                                        <div id="div-gpt-ad-1592989417017-0" style={{ width: '696px', height: '200px', overflow: 'hidden', margin: '0 auto' }}>
                                            <GPT
                                                adUnitPath="/84382175/parenting.com/parenting.com_baby_names_Detailpage"
                                                slotSize={[[336, 280], [728, 90], [300, 250], [696, 200]]}
                                            />
                                        </div>
                                    </div>
                                    <div className="msite-ads-block">
                                        <div id="div-gpt-ad-1592990510558-0" style={{ width: '320px', height: '50px', overflow: 'hidden', margin: '0 auto' }}>
                                            <GPT
                                                adUnitPath="/84382175/parenting.com/pparenting.com_baby_names_Detailpage-Msite"
                                                slotSize={[[320, 100], [320, 50], [336, 280], [300, 250]]}
                                            />
                                        </div>
                                    </div>
                                </div> */}
                                { ((_details[0].similarnames).length > 0) ? 
                                    (<div className="similar_name_cont">
                                        <h2 className="similar M16_42">{`Similar Names For ${_details[0].babyname}`}</h2> 
                                        <ul className="names-list">
                                            {
                                                _details[0].similarnames.map((value, key) => (
                                                <li key={key} id={value.recordid}>
                                                    <div onClick={(e) => actions.tonamedetails(e,`${value.recordid}`, `${value.name}`)} className="name-info">
                                                        <a href={service.getRedirectUrl(`/baby-names/meaning-of-${value.name.replace(/-/g, "").replace(/ /g, "-").toLowerCase()}/`)} title={value.name}>
                                                            {checkGender(value.gender)}
                                                            <div className="names">
                                                                <div className="baby-name M15_42">{value.name}</div>
                                                                <span className="nm-ming R12_9e">{value.meaning}</span>
                                                            </div>
                                                        </a>
                                                    </div>

                                                    {
                                                        (value.isShortlist) ? 
                                                            (
                                                            <div className="right">
                                                                <span className="heart-icon similarnames_hearticon right isChecked" data-icon-font="}" onClick={(e) => this.removeFromColl(`${value.recordid}`,`${value.favouriteid}` , `${value.name}`, e)} data-favId={value.favouriteid}></span>
                                                            </div>
                                                            )
                                                        :
                                                            (
                                                            <div className="right">
                                                                <span className="heart-icon similarnames_hearticon right" data-icon-font="+" onClick={(e) => this.heartclick(e, `${value.recordid}`, `${value.name}`)}></span>
                                                            </div>
                                                            )
                                                        }
                                                </li>)
                                            )
                                            }
                                        </ul>
                                    </div>) 
                                    : '' 
                                }

                                <div className="name-added">
                                    <div className="nm-add">
                                        <span>
                                        </span>
                                    </div>
                                </div>
                                {this.CollectionListPopup (_collectionListData, recordID,babynametoadd, this)}

                                <div className="collectionListCont" onClick={(e) => actions.tofavNameCollection(this)}>
                                    <span className="icon collectionIcon" data-icon-font="&#xe044;"></span>
                                </div>
                            </div>
                        ) : 
                        (
                            <div className="error-container">
                                <div>Ooops... Error 404</div>
                                <div>Sorry, but the page you are looking for doesn't exist.</div>
                                <div>You can go to the <Link to={service.getRedirectUrl("/baby-names/")}>HOMEPAGE</Link></div>
                            </div>
                        )
                    }
                    </div>
                </div>
            </main>
        )
    }
}

export default BabynameDetail



// WEBPACK FOOTER //
// src/shared/baby-names/BabynameDetail.js